import React, { createContext, useContext, useState } from "react";
const LanguageSelectorContext = createContext({
  suppressed: false,
  setSuppressed: () => {}
});
export const useLanguageSelectorControl = () => useContext(LanguageSelectorContext);
export const LanguageSelectorProvider = _ref => {
  let {
    children
  } = _ref;
  const [suppressed, setSuppressed] = useState(false);
  return /*#__PURE__*/React.createElement(LanguageSelectorContext.Provider, {
    value: {
      suppressed,
      setSuppressed
    }
  }, children);
};